import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  woocommerceMatchResolved,
  woocommerceMatchPickerDismiss,
} from "../plugins/plugin.redux";

const headerStyle = {
  borderBottom: "transparent",
};

const bodyStyle = {
  padding: "0rem 1rem 1rem 1rem",
  display: "flex",
  flexDirection: "column",
};

const introStyle = {
  fontSize: "12px",
  color: "#333",
  marginBottom: "0.75rem",
  lineHeight: "1.4",
};

const rowStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0.5rem 0.75rem",
  border: "1px solid #D4D4D5",
  borderRadius: "4px",
  marginBottom: "0.4rem",
};

const candidateInfoStyle = {
  display: "flex",
  flexDirection: "column",
  fontSize: "12px",
  color: "#202124",
  flex: 1,
};

const nameStyle = {
  fontWeight: 700,
  color: "#00197B",
};

const metaStyle = {
  color: "#666",
  fontSize: "11px",
};

const footerStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginTop: "0.5rem",
  gap: "0.5rem",
};

const linkButtonStyle = {
  backgroundColor: "#00197B",
  border: "none",
  fontSize: "12px",
  padding: "4px 12px",
};

const formatCandidate = (c) => {
  const name = [
    c.first_name || c.billing?.first_name,
    c.last_name || c.billing?.last_name,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();
  return {
    id: c.id,
    name: name || c.username || `WC #${c.id}`,
    email: c.email || c.billing?.email || "",
    phone: c.billing?.phone || "",
    date_created: c.date_created || "",
  };
};

const ModalWoocommerceMatchPickerComponent = ({
  matchPicker,
  woocommerceMatchResolved,
  woocommerceMatchPickerDismiss,
}) => {
  const { t } = useTranslation();
  const open = !!matchPicker?.open;
  const matches = matchPicker?.matches || [];
  const pendingPayload = matchPicker?.pendingPayload || null;
  const allowCreateNew =
    !!pendingPayload && pendingPayload.mode !== "background";

  const handleLink = (candidate) => {
    woocommerceMatchResolved({
      action: "link",
      wcCustomerId: candidate.id,
      originalPayload: pendingPayload,
    });
  };

  const handleCreateNew = () => {
    woocommerceMatchResolved({
      action: "create",
      originalPayload: pendingPayload,
    });
  };

  const handleCancel = () => {
    woocommerceMatchPickerDismiss();
  };

  return (
    <Modal
      size="md"
      show={open}
      onHide={handleCancel}
      centered
      className="select-modal"
    >
      <Modal.Header closeButton style={headerStyle}>
        <span style={{ fontWeight: 700, color: "#00197B", fontSize: "14px" }}>
          {t("posMatch.title", "Linkear con cliente de SpectrePOS")}
        </span>
      </Modal.Header>
      <Modal.Body style={bodyStyle}>
        <div style={introStyle}>
          {t(
            "posMatch.intro",
            "Encontramos varios clientes en SpectrePOS que podrían ser el mismo bowler. Selecciona el correcto para linkearlo, o crea uno nuevo.",
          )}
        </div>
        {matches.map((raw) => {
          const c = formatCandidate(raw);
          return (
            <div key={c.id} style={rowStyle}>
              <div style={candidateInfoStyle}>
                <span style={nameStyle}>{c.name}</span>
                <span style={metaStyle}>
                  {c.email || "—"}
                  {c.phone ? ` · ${c.phone}` : ""}
                </span>
              </div>
              <Button
                onClick={() => handleLink(raw)}
                style={linkButtonStyle}
                size="sm"
              >
                {t("posMatch.linkButton", "Linkear")}
              </Button>
            </div>
          );
        })}
        <div style={footerStyle}>
          <Button variant="outline-secondary" size="sm" onClick={handleCancel}>
            {t("posMatch.cancelButton", "Cancelar")}
          </Button>
          {allowCreateNew && (
            <Button
              variant="primary"
              size="sm"
              onClick={handleCreateNew}
              style={linkButtonStyle}
            >
              {t("posMatch.createNewButton", "Crear nuevo")}
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const ModalWoocommerceMatchPicker = connect(
  (state) => ({
    matchPicker: state.plugin.matchPicker,
  }),
  {
    woocommerceMatchResolved,
    woocommerceMatchPickerDismiss,
  },
)(ModalWoocommerceMatchPickerComponent);
